import { formatSsn, P, Text, useText } from "@sveabank/cc-common";
import { useUser } from "../../hooks/useUser";
import type { Signer } from "../../types/signing";

type Props = {
	signer: Signer;
};

const SignerInformation = ({ signer }: Props) => {
	const [t, texts] = useText();
	const { getLoggedInUser } = useUser();
	const currentSsn = getLoggedInUser().bankIdUser.bankIdNumber;
	const isCurrentUser = signer.nationalId === currentSsn;
	return (
		<div className="tablet:flex-row tablet:gap-4 tablet:self-end flex flex-col gap-0 self-start py-4">
			<P>
				<Text bold>{`${signer.firstName} ${signer.lastName} `}</Text>
				{isCurrentUser && t(texts.common.you)}
			</P>
			<P>{formatSsn(signer.nationalId)}</P>
		</div>
	);
};

export default SignerInformation;
